import React from 'react';
import { useNavigate } from "react-router-dom";
import { TournamentNewsItem } from '../../utils/apiClient';

export const TournamentCard = ({ tournament }: { tournament: TournamentNewsItem }) => {
  const navigate = useNavigate();

  return (
    <div className="tournament-card" onClick={() => navigate(`/tournaments/${tournament.id}`)}>
      <h3>{tournament.name}</h3>
      <p><strong>Город:</strong> {tournament.location}</p>
      <p><strong>Дата:</strong> {new Date(tournament.startDate!).toLocaleDateString()} - {new Date(tournament.endDate!).toLocaleDateString()}</p>
      {tournament.registrationEndDate && (
        <p><strong>Дата регистрации:</strong> {new Date(tournament.registrationEndDate).toLocaleDateString()}</p>
      )}
    </div>
  );
};
